import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { adminHttp } from "~/Admin/services/http";
import { connect } from "react-redux";
import Travel from '../../../Pages/RsvpRegistration/Travel/Travel';

import "~/Pages/RsvpRegistration/registration.scss";
import { guestTravel } from '../../../services/adapters/guest';
import { toast } from 'react-toastify';


const AdminEditHotelRooms = ({ guest, event, onChange, dispatch, ...rest }) => {

    const [show, setShow] = useState(false);
    const [error, setError] = useState(null);

    const currentFormData = guestTravel(guest);

    const [form, setForm] = useState({
        travel_method: guest.requirement.travel_method || 'flight',
        travel_circuit_only: guest.requirement.travel_circuit_only || false,
        travel_enabled: guest.requirement.travel_enabled || false,
        travel_ground_transfers: guest.requirement.travel_ground_transfers || false,
        flight: {
            outbound: guest.requirement.outbound_flight || {},
            inbound: guest.requirement.inbound_flight || {},
        },
        train: {
            arrival_station: '',
            arrival_date: null,
            arrival_time: null,
            departure_station: '',
            departure_date: null,
            departure_time: null,
            comments: ''
        },
        car: guest.requirement.car || {}
    });

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleSubmit = () => {
        toast.promise(
            adminHttp.put(`/guests/${guest.id}/travel`, form),
            {
                pending: 'Saving Flight & travel...',
                success: {
                    render() {
                        setError(null);
                        setShow(false);
                        onChange();
                        'Flight & travel saved'
                    }
                },
                error: {
                    render(error) {
                        setError(error.data?.response?.data);
                        return 'Something went wrong!'
                    }
                }
            }
        )
    };

    useEffect(() => {
        setForm({ ...form, ...currentFormData });
    }, []);

    return (
        <>
            <button {...rest} onClick={handleShow}>Edit Flight & Travel</button>

            <Modal className="guestpreview-modal" show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Flight & Travel</Modal.Title>
                </Modal.Header>

                <Modal.Body className="container-registration">
                    <Travel
                        guest={guest}
                        formData={form}
                        isAdmin={true}
                        onChange={setForm}
                        errors={error}
                    />
                </Modal.Body>

                <Modal.Footer>
                    <button className="btn btn-secondary btn-xs" onClick={handleClose}>
                        Cancel
                    </button>
                    <button className="btn btn-primary btn-xs" onClick={handleSubmit}>
                        Save
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
});

export default connect(mapStateToProps)(AdminEditHotelRooms);
